import { Link } from 'gatsby'
import {
  Button,
  Modal,
  ModalProps,
  Space,
  Text,
  Upload,
  UploadProps,
} from 'components/common'

type OmittedModalProps = Omit<
  ModalProps,
  'title' | 'width' | 'bodyStyle' | 'footer'
>
type PickedUploadProps = Pick<UploadProps, 'onChange' | 'onDrop'>
export interface ImportModalProps
  extends OmittedModalProps,
    PickedUploadProps {}

// drag and Drop In Modal
const { Dragger } = Upload

export const ImportModal = ({
  onCancel,
  onDrop,
  onChange,
  ...restModalProps
}: ImportModalProps): JSX.Element => {
  return (
    <Modal
      title="顧客情報をインポートする"
      width={700}
      bodyStyle={{ height: 400 }}
      onCancel={onCancel}
      footer={
        <Space>
          <Button onClick={onCancel}>キャンセル</Button>
          <Button type="primary">顧客情報をインポートする</Button>
        </Space>
      }
      {...restModalProps}
    >
      <Text>
        {/* add Sample CSV Here */}
        <Link to={'./'}>サンプル CSV ファイルをダウンロードして、</Link>
        要求されているフォーマットの例を御覧ください。
      </Text>
      <Dragger name="file" multiple onChange={onChange} onDrop={onDrop}>
        <Upload name="file" multiple onChange={onChange} onDrop={onDrop}>
          <Button>ファイルをアップロードする</Button>
        </Upload>
        <p className="ant-upload-text">
          または、ファイルをドロップしてアップロード
        </p>
      </Dragger>
    </Modal>
  )
}
